export const DIRECT_DEPOSIT = "ACH"
export const CHECK = "CHK"
export const PUSH_TO_DEBIT = "P2D"
export const ECHECK = "ECHK"
export const VIRTUAL_CARD = "VC"

export const ALL_PAYMENT_METHODS = [
    DIRECT_DEPOSIT,
    CHECK,
    PUSH_TO_DEBIT,
    ECHECK,
    VIRTUAL_CARD
]